import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { postDetails } from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import CommonTable, { TableColumn } from "../../components/Table/CommonTable";
import LayoutContainer from "../../components/Containers/LayoutContainer";
import PageHeader from "../../components/PageHeader/PageHeader";
import profileIcon from '../../assets/default-profile.png';

import {
  ArrowLeftSquareFill,
  Download,
  HandThumbsUp,
  Trash3Fill,
} from "react-bootstrap-icons";
import Modal from "react-bootstrap/Modal";
import { useAppDispatch } from "../../store/storeRequests";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import { showToast, hideToast } from "../../store/Toast/toast.slice";
import { Button } from "react-bootstrap";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import formatDate from "../../utils/helpers/formatDate";
import sortByRecentDate from "../../utils/helpers/sortByRecentDate";
import defaultProfile from "../../assets/default-profile.png";
// import profileIcon from "../../assets/default-profile.png";

interface Video {
  id: number;
  userName: string;
  profile: string;
  title: string;
  file_name: string;
  likes: number;
  date: string;
  status: number;
}

interface LikedUser {
  id: number;
  profile: string;
  username: string;
  created: string;
}

const VideoChallengeDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [data, setData] = useState<Video[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState<string>("");
  const [likedUsers, setLikedUsers] = useState<LikedUser[]>([]);
  const [loading, setLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState<Set<number>>(new Set());
  const dispatch = useAppDispatch();

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        dispatch(showLoader("Loading Data..."));
        const response = await postDetails(
          APIList.GET_VIDEO_DETAILS_BY_FOLDER_ID,
          { id }
        );
        setData(response.data);
        console.log(response.data);
        // console.log(response.data);
      } catch (error) {
        console.error("Error fetching videos:", error);
      } finally {
        dispatch(hideLoader());
      }
    };

    fetchVideos();
  }, [id]);

  const redirect = () => {
    navigate("/video-challenge");
  };

  const handleDownloadAll = async () => {
    try {
      dispatch(showLoader("Generating ZIP..."));
      const zip = new JSZip();
      const folder = zip.folder("videos");

      if (data.length === 0) {
        console.error("No videos to download.");
        dispatch(hideLoader());
        return;
      }

      const videoFetchPromises = data.map(async (video, index) => {
        try {
          const videoUrl = video.file_name;
          const filenameObj = video.file_name.split('/');
          video.title = filenameObj[filenameObj.length -1];


          if (!videoUrl) {
            console.error(`No video URL found for video: ${video.title}`);
            return;
          }

          const response = await fetch(videoUrl);

          if (!response.ok) {
            console.error(
              `Error downloading video ${video.title}: ${response.statusText}`
            );
            return;
          }

          const videoBlob = await response.blob();
          const fileName = `${ video.title || `video_${index + 1}`}.mp4`;

          folder?.file(fileName, videoBlob); // Add the video to the zip folder
        } catch (error) {
          console.error(`Error downloading video ${video.title}:`, error);
        }
      });

      await Promise.all(videoFetchPromises);

      if (!folder || Object.keys(folder.files).length === 0) {
        console.error("No valid videos to download.");
        dispatch(hideLoader());
        return;
      }

      const content = await zip.generateAsync({ type: "blob" });
      saveAs(content, "videos.zip");
    } catch (error) {
      console.error("Error generating ZIP file:", error);
    } finally {
      dispatch(hideLoader());
    }
  };

  const handleVideoPreview = (videoUrl: string) => {
    setSelectedVideo(videoUrl);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedVideo("");
  };

  const deleteItemById = async (item: Video) => {
    try {
      const response = await postDetails(APIList.DELETE_VIDEO, {
        id: item.id,
      });

      if (response.status === "Failed") {
        console.log("Cannot delete video");
        return;
      }

      setData((prevData) => prevData.filter((row) => row.id !== item.id));
      console.log("Video deleted");
      dispatch(showToast("Deleted Succesfully."));
      setTimeout(() => dispatch(hideToast()), 3000);
    } catch (error) {
      console.error("Error deleting video:", error);
    }
  };

  const handleCheckboxChange = (selectedIds: Set<number>) => {
    console.log(selectedIds);
    setSelectedItems(selectedIds);
  };

  const handleBulkDelete = async () => {
    try {
      for (const id of selectedItems) {
        const itemToDelete = data.find((item) => item.id === id);
        if (itemToDelete) {
          await deleteItemById(itemToDelete);
        }
      }
      setSelectedItems(new Set());
      setShowDeleteModal(false);
    } catch (error) {
      console.error("Error deleting items:", error);
    }
  };

  const handleCloseDeleteModal = () => setShowDeleteModal(false);

  const handleLikes = async (item: Video) => {
    try {
      setLoading(true);
      const response = await postDetails(APIList.GET_VIDEO_LIKE_DATA, {
        id: item.id,
      });
      if(Array.isArray(response.data)){
      
        const sortedLikes: LikedUser[] = sortByRecentDate(response.data, "created")
        setLikedUsers(sortedLikes);
      } else{
        setLikedUsers([]);
      }
      setShowModal(true);
      console.log("likes",response.data);
    } catch (error) {
      console.error("Error fetching liked users:", error);
    } finally {
      setLoading(false);
    }
  };

  const buttons = [
    {
      label: "Delete",
      theme: "danger",
      icon: <Trash3Fill />,
      onClick: () => setShowDeleteModal(true),
      disabled: selectedItems.size === 0,
    },
    {
      label: "Download All Videos",
      theme: "danger",
      icon: <Download />,
      onClick: handleDownloadAll,
    },
    {
      label: "Back to Main List",
      theme: "danger",
      icon: <ArrowLeftSquareFill />,
      onClick: redirect,
    },
  ];

  const columns: TableColumn[] = [
    { key: "username", label: "User Name", sortable: true, dataType: "string" },
    {
      key: "profile",
      label: "Profile Pic",
      dataType: "image",
      render: (item: Video) => (
        <img
          src={item.profile ? item.profile : profileIcon}
          alt={item.userName}
          style={{
            width: "40px",
            height: "40px",
            objectFit: "cover",
          }}
        />
      ),
    },
    { key: "caption", label: "Title", dataType: "string" },
    { key: "thumb_name", label: "Thumb Image",
      //  dataType: "image" 
      render: (item) => {
        if (item.thumb_name) {
          return <img src={item.thumb_name} alt="Profile" width={50}/>;
        }
      },
    },
    {
      key: "file_name",
      label: "Video Preview",
      dataType: "button",
      button: {
        label: "View",
        onClick: (item) => handleVideoPreview(item.file_name),
      },
    },
    {
      key: "likecount",
      label: "Likes",
      dataType: "button",
      sortable: true,
      // button: {
      //   label: (item) => (
      //     <div style={{ display: "flex", alignItems: "center" }}>
      //       <HandThumbsUp style={{ marginRight: "5px" }} />
      //       {item.likecount || 0}
      //     </div>
      //   ),
      //   onClick: handleLikes,
      // },
      render: (item)=>(
        <div 
        style={{ display: "flex",
           alignItems: "center",
           justifyContent: "center",
           gap: "2",
           width: "58px",
           margin: "auto",
           padding: "6px 12px",
           color: "#fff",
           backgroundColor: "rgb(255, 204, 0)",
           cursor: "pointer"
          }}
        onClick={()=> handleLikes(item)}
        // className="btn-secondary"
        >
          <HandThumbsUp style={{ marginRight: "5px" }} />
            {item.likecount || 0}
          </div>
      )
    },
    {
      key: "created",
      label: "Date",
      // dataType: "string",
      sortable: true,
      render: (record) =>
        new Date(record.created).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }),
    },
  ];

  return (
    <LayoutContainer title="View Videos">
      <div className="page-header d-flex align-items-center justify-content-left dashboard-container h-100">
        <h2>
          <i className="page-header-icon fa fa-home"></i>
          View Videos
        </h2>
      </div>
      <PageHeader buttons={buttons} />
      <CommonTable<Video>
        data={data}
        columns={columns}
        onDelete={deleteItemById}
        onCheckboxChange={handleCheckboxChange}
        pagination={true}
        rowsPerPage={10}
        actions={{
          delete: true,
          checkbox: true,
        }}
      />
      {/* Modal Component */}
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered
        dialogClassName={selectedVideo ? "" : "view-modal-size"}
      >
        <Modal.Header closeButton>
          <Modal.Title>{selectedVideo ? "Video Preview" : "Likes"}</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            display: "flex",
            justifyContent: selectedVideo ? "center" : "flex-start",
            alignItems: "start",
            // padding: selectedVideo ? 0 : "20px",
            maxHeight:"400px",
          overflowY:"auto"
          }}
        >
          {selectedVideo ? (
            <video
              src={selectedVideo}
              controls
              tabIndex={-1}
              style={{
                width: "100%",
                height: "100%",
                maxHeight: "60vh",
                objectFit: "contain",
                outline: "none",
              }}
              
            />
          ) : (
            <>
              {loading ? (
                <p>Loading...</p>
              ) : likedUsers.length > 0 ? (
                <ul style={{ listStyleType: "none", padding: 0 }}>
                  {likedUsers.map((user) => (
                    <li
                      key={user.id}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "10px",
                      }}
                    >
                      <img
                        src={user.profile ? user.profile : profileIcon}
                        // alt={user.username}
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "50%",
                          marginRight: "10px",
                        }}
                      />
                      <div className="d-flex flex-column">
                      <span className="fw-semibold font-16 mb-1">{user.username}</span>
                      <span className="font-12">{user.created 
                      ? new Date(user.created).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })
                      : "Created date not available"}</span>
                      </div>
                    </li>
                  ))}
                </ul>
              ) : (
                <p>No data found.</p>
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          {/* <button className="btn-danger" onClick={handleCloseModal}>
            Close
          </button> */}
          <Button
          variant="danger"
          onClick={handleCloseModal}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        centered
        className="deleteAll-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete?</p>
          <Button className="btn-danger" onClick={handleBulkDelete}>
            Delete
          </Button>
          <Button
            className="btn-warning text-white"
            onClick={handleCloseDeleteModal}
          >
            Cancel
          </Button>
        </Modal.Body>
      </Modal>
    </LayoutContainer>
  );
};

export default VideoChallengeDetails;
